import { Function } from "../../enums/authorization";

export const SideBarData = [
    {
        routeLink: 'tk',
        icon: 'dashboard',
        name: Function.A_P_DASHBOARD,
        label: "Thống kê",
        parentidx: 'tk',
        subItems: [
            {
                routeLink: 'clb',
                icon: 'category',
                name: Function.A_C_DASHBOARDLHLCLB,
                label: "Thống kê - CLB"
            },
            {
                routeLink: 'khoi',
                icon: 'summarize',
                name: Function.A_C_DASHBOARDLHLKHOI,
                label: "Thống kê - Khối"
            },
            {
                routeLink: 'lop',
                icon: 'analytics',
                name: Function.A_C_DASHBOARDLHLLOP,
                label: "Thống kê - Lớp"
            },
            {
                routeLink: 'dt',
                icon: 'insights',
                name: Function.A_C_DASHBOARDLHLDT,
                label: "Thống kê - Đạo tràng"
            }
        ]
    }, 
    {
        routeLink: 'khoa-sinh',
        icon: 'school',
        name: Function.A_C_MNCLBLAHAULABTKS,
        label: "Khóa sinh (Làm bài tập)"
    }, 
    {
        routeLink: 'dt-mng',
        icon: 'groups',
        name: Function.A_C_MNCLBLAHAULADT,
        label: "Khóa sinh La Hầu La (ĐT)"
    },
    {
        routeLink: 'lop-mng',
        icon: 'groups',
        name: Function.A_C_MNCLBLAHAULALOP,
        label: "Khóa sinh La Hầu La (Lớp)"
    },
    {
        routeLink: 'khoi-mng',
        icon: 'groups',
        name: Function.A_C_MNCLBLAHAULAKHOI,
        label: "Khóa sinh La Hầu La (Khối)"
    },  
    {
        routeLink: 'clb-mng',
        icon: 'groups',
        name: Function.A_C_MNCLBLAHAULA,
        label: "Khóa sinh CLB La Hầu La"
    },
    {
        routeLink: 'bqc-bcn',
        icon: 'assignment',
        name: Function.A_C_MNCLBLAHAULABCN,
        label: "Phụ trách Khối & CNL",
        parentidx: 'bqc-bcn',
        subItems: [
            {
                routeLink: 'bqc',
                icon: 'assignment_ind',
                name: Function.A_C_MNCLBLAHAULABCN,
                label: "Quản lý phụ trách Khối"
            },
            {
                routeLink: 'bcn',
                icon: 'school',
                name: Function.A_C_MNCLBLAHAULABCN,
                label: "Quản lý chủ nhiệm lớp"
            },
        ]
    },
    {
        routeLink: 'bpt-bcn-k',
        icon: 'assignment',
        name: Function.A_C_MNCLBLAHAULABCNFKHOI,
        label: "Phụ trách Khối & CNL (Khối)",
        parentidx: 'bpt-bcn-k',
        subItems: [
            {
                routeLink: 'bpt',
                icon: 'assignment_ind',
                name: Function.A_C_MNCLBLAHAULABCNFKHOI,
                label: "Quản lý phụ trách Khối"
            },
            {
                routeLink: 'bcn',
                icon: 'school',
                name: Function.A_C_MNCLBLAHAULABCNFKHOI,
                label: "Quản lý chủ nhiệm lớp"
            },
        ]
    },
    {
        routeLink: 'bcn-l',
        icon: 'school',
        name: Function.A_C_MNCLBLAHAULABCNFLOP,
        label: "Quản lý chủ nhiệm lớp (Lớp)"
    },
    {
        routeLink: 'bt',
        icon: 'auto_stories',
        name: Function.A_C_MNCLBLAHAULABT,
        label: "Bài tập RLĐĐ",
        parentidx: 'bt-clb',
        subItems: [
            {
                routeLink: 'cb',
                icon: 'rule',
                name: Function.A_C_MNCLBLAHAULABT,
                label: "Quản lý Bài tập Khối 1,2"
            },
            {
                routeLink: 'nc',
                icon: 'self_improvement',
                name: Function.A_C_MNCLBLAHAULABT,
                label: "Quản lý Bài tập Khối 3,4"
            },
        ]
    },
    {
        routeLink: 'bt-khoi',
        icon: 'auto_stories',
        name: Function.A_C_MNCLBLAHAULABTKHOI,
        label: "Bài tập RLĐĐ (Khối)"        
    },
    {
        routeLink: 'bt-lop',
        icon: 'auto_stories',
        name: Function.A_C_MNCLBLAHAULABTLOP,
        label: "Bài tập RLĐĐ (Lớp)"        
    },
    {
        routeLink: 'bt-dt',
        icon: 'auto_stories',
        name: Function.A_C_MNCLBLAHAULABTDT,
        label: "Bài tập RLĐĐ (ĐT)"        
    },
    {
        routeLink: 'k-l-mng',
        icon: 'account_tree',
        name: Function.A_C_MNCLBLAHAULAKLLHL,
        label: "Quản lý Khối-Lớp LHL"
    },
    {
        routeLink: 'sp-clb',
        icon: 'contact_support',
        name: Function.A_C_SPCLBLHLBLD,
        label: "Liên hệ hỗ trợ (BLĐ)"
    },
     {
        routeLink: 'sp-k',
        icon: 'contact_support',
        name: Function.A_C_SPCLBLHLKHOI,
        label: "Liên hệ hỗ trợ (Khối)"
    },
     {
        routeLink: 'sp-l',
        icon: 'contact_support',
        name: Function.A_C_SPCLBLHLLOP,
        label: "Liên hệ hỗ trợ (Lớp)"
    },
     {
        routeLink: 'sp-dt',
        icon: 'contact_support',
        name: Function.A_C_SPCLBLHLDT,
        label: "Liên hệ hỗ trợ (ĐT)"
    },
];
